import ClientInfo, { AccordionId } from './ClientInfo';

export default ClientInfo;
export { AccordionId };
